import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import Carousel3d from "vue-carousel-3d";
import router from "./router";
import store from "./store";
import headers from "@/components/Header";
import footer from "@/components/Footer";
import banner from "@/components/Banner";
import pagination from "@/components/Pagination";
import decorate from "@/components/decorate";
import Nodata from "@/components/Nodata";
import "@/assets/style/element-variables.scss";
import { formatTime } from "@/utils/tools";
import Dialog from "@/components/dialog";
import animated from "animate.css/animate.compat.css";

Vue.prototype.$formatTime = formatTime;
Vue.prototype.$baseUrl = process.env.VUE_APP_BASE_API;
Vue.component("Dialog", Dialog);
Vue.component("Nodata", Nodata);
Vue.component("Header", headers);
Vue.component("Decorate", decorate);
Vue.component("Footer", footer);
Vue.component("Banner", banner);
Vue.component("Pagination", pagination);
Vue.use(ElementUI);
Vue.use(Carousel3d);
Vue.use(animated);
import { i18n } from "./utils/i18n";
Vue.use(animated);
Vue.config.productionTip = false;
Vue.directive("animated", {
  inserted: function (el) {
    el.classList.add("animated", "slideInDown");
  },
});
new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");
export default Vue;
